import logo from '../../assets/images/zettablock-logo-icon.svg';

export default function LogoIcon({ className }: { className?: string }) {
  return <img src={logo} alt='ZettaBlock logo' className={className} />;
}
